import {SupplierList, SupplierRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

export const SupplierListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<SupplierList> = {
        title: "Proveedores",
        onClick: "/app/admin/accounting/supplier",
        headers: [
            {title: "Nombre"},
            {title: "NIF"},
            {title: "Email"},
            {title: "Teléfono"},
            {title: "IBAN"},
            {title: "Cuenta contable"},
        ],
        decorator: (bean: SupplierList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {bean.name}
                </TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>{bean.nif ?? "-"}</TableCell>
                <TableCell>{bean.email ?? "-"}</TableCell>
                <TableCell>{bean.telephone ?? "-"}</TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>{bean.iban ?? "-"}</TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>{bean.accountingAccount?.code ?? "-"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(SupplierRestControllerApiFactory);
            return ctrl.pageSupplier(currentPage, size, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
